//@flow

import React, { Fragment } from 'react';
import { DropdownItem } from 'reactstrap';

type Props = {
  logout: () => void,
  openLoginModal: () => void,
  openSignUpModal: () => void,
  isLoggedIn: Boolean,
};

const LoginOrLogout = ({ logout, openLoginModal, openSignUpModal, isLoggedIn }: Props) => {
  return (
    <div>
      {isLoggedIn ? (
        <DropdownItem onClick={() => logout()}> Log out</DropdownItem>
      ) : (
        <Fragment>
          <DropdownItem onClick={() => openLoginModal()}>Log in</DropdownItem>
          <DropdownItem onClick={() => openSignUpModal()}>Sign up</DropdownItem>
        </Fragment>
      )}
    </div>
  );
};

export default LoginOrLogout;



// WEBPACK FOOTER //
// ./src/components/TopBar/LoginOrLogout.jsx